import React, { useEffect, useState } from "react";

const AllNews = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch data
  const fetchData = async () => {
    try {
      const response = await fetch("https://mirai-server.vercel.app/news-data");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Delete item
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (!confirmDelete) return;

    try {
      const response = await fetch(`https://mirai-server.vercel.app/newsData/${id}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.deletedCount === 1) {
        alert("Item deleted successfully!");
        setData(data.filter((item) => item._id !== id)); // Update the state to reflect the deleted item
      } else {
        alert("Failed to delete the item.");
      }
    } catch (err) {
      alert(`Error: ${err.message}`);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="bg-gray-100 min-h-screen">
    <h1 className="w-full bg-white px-6 py-8 shadow-lg text-4xl font-mono">
     All Column
   </h1>


      <div class="relative overflow-x-auto mx-6 mt-10 border  p-5 m-6 bg-white shadow-lg">
        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th
                scope="col"
                class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
              >
                #
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
              >
                Image
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
              >
                News Title
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
              >
                News Category
              </th>
              <th
                scope="col"
                class="px-6 py-3 font-roboto text-lg font-semibold text-gray-900"
              >
                Delete
              </th>
            </tr>
          </thead>
          {data.map((item, index) => (
            <tbody>
              <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  class="px-6 py-4 font-roboto text-lg text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {index + 1}
                </th>
                <td class="px-6 py-4 font-roboto text-lg">
                  <img
                    class="w-10 h-10 rounded-full"
                    src={item.singleImage}
                    alt="Rounded avatar"
                  />
                </td>
                <td class="px-6 py-4 font-roboto text-lg">{item.title}</td>
                <td class="px-6 py-4 font-roboto text-lg">{item.category}</td>
                <td class="px-6 py-4 font-roboto text-lg">
                  <button onClick={() => handleDelete(item._id)}>Delete</button>
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      </div>
    </div>
  );
};

export default AllNews;
